/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import "./Header.css";

import { listProfileImageAction } from "../../store/actions/profileAction";
import { connect, useDispatch, useSelector } from "react-redux";
import { PROFILE_CONSTANT_RESET } from "../../store/constants/constants";
import NoDataFound from "../Common/NoDataFound/NoDataFound";
import SearchResultToggler from "./assets/images/search_result_toggler.svg";

import ReactDOM from "react-dom";
import React, { useEffect, useRef, useState, Fragment, useMemo } from "react";
import logo from "../../assets/images/logo.png";
// import logoText from "../../assets/images/logo-text.png";
import logoText from "../../assets/images/landbook.png";
import avatarOne from "../../../src/assets/images/avatar/1.jpg";
import { Link, useNavigate } from "react-router-dom";
import Logout from "../../controllers/auth/Logout";
import NO_BUSINESS_LOGO from "../../assets/images/no-image.png";
import {
  Avatar,
  Backdrop,
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Popover,
  Typography,
} from "@mui/material";
import { stringAvatar } from "../../helpers/stringAvatar";
/* Swiper */
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation } from "swiper";
// import Avatar from "../Avatars/Avatar/Avatar";

import HeaderSearchPropertyContent from "./HeaderSearchPropertyContent/HeaderSearchPropertyContent";

import { Colors } from "../../Colors/Colors";
import { getDownloadURL, getStorage, listAll, ref } from "firebase/storage";
import { getAuth } from "firebase/auth";
import TotalResultAndFilter from "./TotalResultAndFilter/TotalResultAndFilter";
import LeadsContent from "./SearchClientsContent/SearchClientsContent";
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
import PropertySingleDealContent from "../Deals/PropertySingleDealContent/PropertySingleDealContent";
import useOnclickOutside from "react-cool-onclickoutside";
import ChevronRightOutlinedIcon from "@mui/icons-material/ChevronRightOutlined";
import ChevronLeftOutlinedIcon from "@mui/icons-material/ChevronLeftOutlined";
import AgentSingleDealContent from "../Deals/AgentSingleDealContent/AgentSingleDealContent";
import Deal from "../../pages/Deals/Deal/Deal";
import GetDealsByStatus from "../../controllers/Enquiries/GetDealsByStatus";
import getSettings from "../../controllers/settings/getSettings";
import LeadSingleDealContent from "../Deals/LeadSingleDealContent/LeadSingleDealContent";
import GetAgentRoles from "../../controllers/agents/getAgentRoles";
import GetAllAgents from "../../controllers/agents/GetAllAgents";
import GetAllDealsController from "../../controllers/Enquiries/GetAllDealsController";
import GetProperties from "../../controllers/properties/getProperties";
import GetAllLeads from "../../controllers/leads/GetAllLeads";
import { getLocalStorageItem } from "../../controllers/localStorage/getLocalStorage";
import HeaderDealContent from "./HeaderDealContent/HeaderDealContent";
import GetNotifications from "../../controllers/users/GetNotifications";
import { intervalToDuration } from "date-fns";
import NotificationsPopup from "./NotificationsPopup/NotificationsPopup";
import { db, onMessageListener } from "../../firebase";
import { collection, doc, getDoc, onSnapshot } from "firebase/firestore";
import useRealTimeNotifications from "./scripts/hook";
import ReactNotificationComponent from "../Notifications/ReadNotifications";
import PushNotifications from "../Notifications/Notifications";
import PropertiesContent from "../../pages/Properties/PropertiesContent/PropertiesContent";
import DealsCard from "../Deals/DealsCard/DealsCard";

import UserListCardDetail from "../UserListCardDetail/UserListCardDetail";
import SearchClientsContent from "./SearchClientsContent/SearchClientsContent";
import SearchAgentsContent from "./SearchAgentsContent/SearchAgentsContent";
import GetTotalAgents from "../../controllers/agents/GetTotalAgents";
import { MultipleQueryTypesense } from "../../Typesense";

const settings = {
  // dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
};

const propertySettings = {
  // dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 2,
  slidesToScroll: 1,
};

const Header = (props) => {
  const dispatch = useDispatch();
  const ListedImageFromStore = useSelector((state) => state.listProfileImage);
  // const { loading, error, products, page, pages } = productList;
  const [ListedImage, setListedImage] = useState("");
  const [ProfileData, setProfileData] = useState({});
  const [IsImageUploading, setIsImageUploading] = useState(false);
  const [isSearchBarFocused, setIsSearchBarFocused] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    async function fetchData() {
      getAuth().onAuthStateChanged(async () => {
        const userId = getAuth().currentUser.uid;
        const userDocument = await doc(db, "users", userId);
        const userSnapshot = await getDoc(userDocument);
        const user = { id: userSnapshot.id, ...userSnapshot.data() };
        setProfileData(user);
      });
    }
    fetchData();
  }, []);

  /* Fetch Profile Data ------------------------------------------- */
  useEffect(() => {
    async function fetchData() {
      getAuth().onAuthStateChanged(async () => {
        const userId = getAuth().currentUser.uid;
        onSnapshot(doc(db, "users", userId), (doc) => {
          const userDoc = doc?.data();
          setProfileData(userDoc);
          // if (JSON.stringify(userDoc) === JSON.stringify({})) {
          //   return;
          // } else {
          //   setProfileData(userDoc);
          // }
        });
      });
    }
    fetchData();
  }, []);

  // List Images Start
  // const listImages = async () => {
  //   getAuth().onAuthStateChanged(() => {
  //     setIsImageUploading(true);
  //     const id = getAuth().currentUser.uid;
  //     listAll(ref(getStorage(), `profile_images/${id}`))
  //       .then(async ({ prefixes, items }) => {
  //         setListedImage(await getDownloadURL(items[0]));
  //         setIsImageUploading(false);
  //       })
  //       .catch(async () => {
  //         setIsImageUploading(false);
  //       });
  //   });
  // };
  /* Fetch Profile Image ------------------------------------------- */
  useEffect(() => {
    async function fetchData() {
      const id = getAuth().currentUser.uid;
      await onSnapshot(doc(db, "users", id), (doc) => {
        setListedImage(doc.data().image_url);
      });
    }
    fetchData();
  }, []);

  // List Images End

  // Currency Settings UseEffect Start
  const [CurrencySettings, setCurrencySettings] = useState({});
  useEffect(() => {
    async function fetchData() {
      const settings = await getSettings();
      setCurrencySettings(settings);
    }
    fetchData();
  }, []);

  let userName = "Loading...";
  let userPhoto = null;

  if (props.userReducer) {
    const {
      userReducer: { displayName, photoUrl },
    } = props;
    userName = displayName;
    userPhoto = photoUrl;
  }

  /* Search Filters */
  const [filters, setFilters] = useState({
    sort: "",
    show: {
      leads: true,
      properties: true,
      publicProperties: true,
      sharedProperties: true,
      agents: true,
      deals: true,
    },
  });
  const changeFilters = (f) => {
    setFilters(f);
  };
  const getFilters = (f) => {
    return filters;
  };

  /* Agents */
  const [hasMore, setHasMore] = useState(true);
  const [Year, setYear] = useState("*");
  const [Filter, setFilter] = useState("newest");
  const [agents, setAgents] = useState([]);
  const LastSnapshot = useRef("*");
  useEffect(() => {
    async function fetchData() {
      await GetTotalAgents().then((agentsData) => {
        setAgents(agentsData);
      });
    }
    fetchData();
  }, []);

  /* Deals */
  const [DealsRaw, setDealsRaw] = useState([]);
  const [Deals, setDeals] = useState([]);
  useEffect(() => {
    async function fetchData() {
      getAuth().onAuthStateChanged(async ({ uid }) => {
        let deals = (await GetAllDealsController()) || [];
        // setDealsRaw([...deals]);
        // let properties = await GetProperties(uid, "*", 0, 100);

        // deals = deals.map((d) => {
        //   return {
        //     ...d,
        //     property: properties.filter((p) => p.id === d.property).pop(),
        //   };
        // });

        // const leads =
        //   (await GetAllLeads(Year, Filter, LastSnapshot.current, 100)).leads ||
        //   [];
        // deals = deals.map((d) => {
        //   return {
        //     ...d,
        //     lead: leads.filter((p) => p.id === d.lead).pop(),
        //   };
        // });
        setDeals([...deals]);
      });
    }
    fetchData();
  }, []);

  /** Popover Logic */
  const [SearchText, setSearchText] = React.useState("");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handlePopoverOpen = (event) => setAnchorEl(event.currentTarget);
  const handlePopoverClose = () => setAnchorEl(null);
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const popoverHiddenBtn = useRef(null);

  /* Detect click outside */
  const [openSearch, setOpenSearch] = useState(false);
  const outsideClickRef = useOnclickOutside(() => {
    setOpenSearch(false);
  });
  useEffect(
    () => setOpenSearch(SearchText === "" ? false : true),
    [SearchText]
  );

  /** Search Query */
  const [Result, setResult] = React.useState({});
  const QueryTypesense = async (params, collection) => {
    const Typesense = require("typesense");
    const production = process.env.REACT_APP_MY_PRODUCTION;

    let client =
      production == 0
        ? new Typesense.Client({
            nearestNode: {
              host: "yu68x349s2cvf7mhp-1.a1.typesense.net",
              port: "443",
              protocol: "https",
            },
            nodes: [
              {
                host: "yu68x349s2cvf7mhp-1.a1.typesense.net",
                port: "443",
                protocol: "https",
              },
            ],
            apiKey: "eIct4f6cKG4NgixJvzJ44AIp31oxO3Qy",
            connectionTimeoutSeconds: 2,
          })
        : new Typesense.Client({
            nearestNode: {
              host: "x1a8iy9s5tbm4u6wp-1.a1.typesense.net",
              port: "443",
              protocol: "https",
            },
            nodes: [
              {
                host: "x1a8iy9s5tbm4u6wp-1.a1.typesense.net",
                port: "443",
                protocol: "https",
              },
            ],
            apiKey: "PAEBwr1upqSLyukWqd24HCDX4IYYm9y2",
            connectionTimeoutSeconds: 2,
          });
    let searchParameters = params;
    const a = await client
      .collections(collection)
      .documents()
      .search(searchParameters);
    return a.hits;
  };
  useEffect(() => {
    async function fetchData() {
      if (SearchText === "") {
        setResult(null);
        return;
      }

      let result = {};
      /** Businesses */
      result.clients = await QueryTypesense(
        {
          q: SearchText,
          query_by: "businessName",
        },
        "clients"
      );

      /** Deals */
      result.businessDeals = await QueryTypesense(
        {
          q: SearchText,
          query_by: "property.propertyTitle",
          filter_by: "bid:=" + getLocalStorageItem("bid"),
        },
        "deals"
      );

      /** Clients */
      result.leads = await QueryTypesense(
        {
          q: SearchText,
          query_by: "name",
          filter_by: "bid:=" + getLocalStorageItem("bid"),
        },
        "leads"
      );
      /** Inventory + Shared With Me Properties*/
      result.properties = await MultipleQueryTypesense(
        {
          searches: [
            {
              q: SearchText,
              query_by: "propertyTitle",
              filter_by: `bid:=${getLocalStorageItem(
                "bid"
              )} && is_deleted:=false`,
            },
            {
              q: SearchText,
              query_by: "propertyTitle",
              filter_by: `sharedParties:=[${getLocalStorageItem(
                "bid"
              )}] && is_deleted:=false`,
            },
          ],
        },
        {
          collection: "properties",
        }
      );

      /** Shared By Me Properties */
      result.sharedProperties = await QueryTypesense(
        {
          q: SearchText,
          query_by: "propertyTitle",
          filter_by: `status:=shared && bid:=${getLocalStorageItem(
            "bid"
          )} && is_deleted:=false`,
        },
        "properties"
      );

      /** Public Properties */
      result.publicProperties = await QueryTypesense(
        {
          q: SearchText,
          query_by: "propertyTitle",
          filter_by: "status:=public",
        },
        "properties"
      );

      /** Agents data */
      result.agents = agents.filter((e) => e.name.indexOf(SearchText) > -1);

      setResult({ ...result, deals: [] });

      /** Deals */
      result.deals = Deals.filter(
        (d) =>
          d?.lead?.name?.indexOf(SearchText) > -1 ||
          d?.property?.propertyTitle?.indexOf(SearchText) > -1
      );
      result.deals = result.deals.map((d) =>
        DealsRaw.filter((f) => f.id === d.id).pop()
      );

      if (result.deals.length === 0) return;

      setResult(result);
    }
    fetchData();
  }, [SearchText]);

  /* Swiper */
  const [swiperRef, setSwiperRef] = useState(null);
  let appendNumber = 4;
  let prependNumber = 1;
  const slideToNextSlide = () =>
    document.querySelector(".swiper .swiper-button-prev").click();
  const slideToPrevSlide = () =>
    document.querySelector(".swiper .swiper-button-next").click();

  /* Scroll Functions */
  const ScrollArrows = (id) => {
    return (
      <div className="d-flex align-items-center h-100">
        <div
          onClick={() => scrollToRight(id)}
          className="bg-white border border-1 mr-3 pointer"
          style={{
            borderRadius: 200,
            borderColor: "#7bc3f8",
            cursor: "pointer",
          }}
        >
          <ChevronLeftOutlinedIcon style={{ fill: "#7bc3f8" }} />
        </div>
        <div
          onClick={() => scrollToLeft(id)}
          className="bg-white border border-1 pointer"
          style={{
            borderRadius: 200,
            borderColor: "#7bc3f8",
            cursor: "pointer",
          }}
        >
          <ChevronRightOutlinedIcon style={{ fill: "#7bc3f8" }} />
        </div>
      </div>
    );
  };
  const scrollToLeft = ({ id }) => {
    const elem = document.getElementById(id);
    elem.scroll({
      left: elem.scrollLeft + 500, //scroll to the bottom of the element
      behavior: "smooth", //auto, smooth, initial, inherit
    });
  };
  const scrollToRight = ({ id }) => {
    const elem = document.getElementById(id);
    elem.scroll({
      left: elem.scrollLeft - 500, //scroll to the bottom of the element
      behavior: "smooth", //auto, smooth, initial, inherit
    });
  };

  const GetTotalResultCount = () => {
    return (
      (Result?.leads?.length || 0) +
      (Result?.properties?.length || 0) +
      (Result?.publicProperties?.length || 0) +
      (Result?.sharedProperties?.length || 0) +
      (Result?.businessDeals?.length || 0) +
      (agents?.length || 0)
      // (Result?.agents?.length || 0) +
      // (Result?.deals?.length || 0)
    );
  };

  window.addEventListener("locationchange", function () {
    setOpenSearch(false);
  });
  window.addEventListener("hashchange", function () {
    setOpenSearch(false);
  });
  window.addEventListener("popstate", function () {
    setOpenSearch(false);
  });

  /* Header DropDown */
  const [DropDown, setDropDown] = useState(false);
  const [ToggleNotification, setToggleNotification] = useState(false);

  const handleNotificationClickDropDown = () => {
    setToggleNotification(!ToggleNotification);
  };
  const handleClickDropDown = () => {
    setDropDown(!DropDown);
  };
  // const closeMenu = () => setDropDown(false);
  const DropDownRef = useOnclickOutside(() => {
    setDropDown(false);
  });
  const NotificationDropDownRef = useOnclickOutside(() => {
    setToggleNotification(false);
  });

  const [BusinessListedImage, setBusinessListedImage] = useState("");
  const [IsBusinessImageDownloading, setIsBusinessImageDownloading] =
    useState(false);

  /* Fetch Business Logo ------------------------------------------- */
  useEffect(() => {
    async function fetchData() {
      await onSnapshot(
        doc(db, "clients", getLocalStorageItem("bid")),
        (doc) => {
          setBusinessListedImage(doc.data());
        }
      );
    }
    fetchData();
  }, []);
  // List Images End

  const businessID = getAuth().currentUser;

  const [Notifications] = useRealTimeNotifications();
  const [show, setShow] = useState(false);
  const [notification, setNotification] = useState({ title: "", body: "" });

  useEffect(() => {
    if (notification.title !== "") {
      setTimeout(() => {
        setShow(false);
        setNotification({ title: "", body: "" });
      }, 5000);
    }
  }, [notification]);

  onMessageListener()
    .then((payload) => {
      setShow(true);
      setNotification({
        title: payload.notification.title,
        body: payload.notification.body,
      });
    })
    .catch((err) => console.log("failed: ", err));

  const [DealsToggler, setDealsToggler] = useState(true);
  const [InventoryPropertiesToggler, setInventoryPropertiesToggler] =
    useState(true);
  const [SharedPropertiesToggler, setSharedPropertiesToggler] = useState(true);
  const [PublicPropertiesToggler, setPublicPropertiesToggler] = useState(true);
  const [ClientsToggler, setClientsToggler] = useState(true);
  const [AgentsToggler, setAgentsToggler] = useState(true);

  return (
    <>
      <header id="app-header">
        <div className="header-left-container">
          <div className="logo">
            <Link to="/user/dashboard" className="">
              <img className="" src={logoText} alt="" />
            </Link>
          </div>
          {BusinessListedImage?.image_url && (
            <div className="business-avatar">
              {!IsBusinessImageDownloading &&
                businessID !== "" &&
                BusinessListedImage !== "" && (
                  <img src={BusinessListedImage?.image_url} />
                )}
            </div>
          )}
        </div>

        <div className="header-center-container">
          <div className="search-container">
            <div className="search_icon">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M23.7871 22.7761L17.9548 16.9437C19.5193 15.145 20.4665 12.7982 20.4665 10.2333C20.4665 4.58714 15.8741 0 10.2333 0C4.58714 0 0 4.59246 0 10.2333C0 15.8741 4.59246 20.4665 10.2333 20.4665C12.7982 20.4665 15.145 19.5193 16.9437 17.9548L22.7761 23.7871C22.9144 23.9255 23.1007 24 23.2816 24C23.4625 24 23.6488 23.9308 23.7871 23.7871C24.0639 23.5104 24.0639 23.0528 23.7871 22.7761ZM1.43149 10.2333C1.43149 5.38004 5.38004 1.43681 10.2279 1.43681C15.0812 1.43681 19.0244 5.38537 19.0244 10.2333C19.0244 15.0812 15.0812 19.035 10.2279 19.035C5.38004 19.035 1.43149 15.0865 1.43149 10.2333Z"
                  fill="#A4A4A4"
                />
              </svg>
            </div>
            <input
              className="search_bar_input"
              type="search"
              placeholder="Search Here"
              aria-label="Search"
              onChange={(e) => setSearchText(e.target.value)}
              onFocus={() => setIsSearchBarFocused(true)}
              onClick={() => setOpenSearch(true)}
              onBlur={() => setIsSearchBarFocused(false)}
            />

            <Fragment>
              {Result && openSearch && (
                <div
                  ref={outsideClickRef}
                  className="global-body-container search-box-container"
                >
                  <TotalResultAndFilter
                    TotalResults={GetTotalResultCount()}
                    {...{
                      changeFilters,
                      getFilters,
                    }}
                  />

                  {filters.show.deals && (
                    <div className="search-deal-container">
                      <div className="deal-card-top">
                        <div className="result">
                          Deals ({Result?.businessDeals?.length})
                        </div>
                        <div
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            if (Result?.businessDeals?.length === 0) {
                              setDealsToggler(true);
                            } else {
                              setDealsToggler(!DealsToggler);
                            }
                          }}
                          className="toggler"
                        >
                          {DealsToggler ? (
                            <img src={SearchResultToggler} alt="" />
                          ) : (
                            <img
                              style={{ transform: "rotateZ(180deg)" }}
                              src={SearchResultToggler}
                              alt=""
                            />
                          )}
                        </div>
                      </div>
                      {DealsToggler && (
                        <div className="deal-card-body">
                          {Result?.businessDeals?.map((e) => {
                            let agentID;
                            let clientID;
                            let propertyID;
                            let thumbnails = [];
                            Object.entries(e.document).map(([key, value]) => {
                              if (key === "agent.id") {
                                agentID = value;
                              }
                              if (key === "client.id") {
                                clientID = value;
                              }
                              if (key === "property.id") {
                                propertyID = value;
                              }
                              if (key === "property.images") {
                                thumbnails = value;
                              }
                            });
                            console.log("agentID", agentID);
                            return (
                              <DealsCard
                                onClick={() => {
                                  setOpenSearch(false);
                                  navigate(
                                    `/user/deals/update/${e.document.id}`
                                  );
                                }}
                                id={e.document.id}
                                key={e.document.id}
                                agent={agentID}
                                status={e.document.currentstatus}
                                interest={e.document.interest}
                                lead={clientID}
                                property={propertyID}
                                createdAt={e.document.createdAt}
                                dealPrice={e.document.dealPrice}
                                // thumbnail={
                                //   e.document.property?.images
                                //     ? e.document.property?.images[0]
                                //     : "https://firebasestorage.googleapis.com/v0/b/property-management-port-12157.appspot.com/o/general%2FloadingImg.gif?alt=media&token=5b6fb56c-aa61-4657-8f48-3a97b507f9c5"
                                // }
                                thumbnail={
                                  thumbnails
                                    ? thumbnails[0]
                                    : "https://firebasestorage.googleapis.com/v0/b/property-management-port-12157.appspot.com/o/general%2FloadingImg.gif?alt=media&token=5b6fb56c-aa61-4657-8f48-3a97b507f9c5"
                                }
                                CurrencySettings={CurrencySettings}
                                openSearch={openSearch}
                              />
                            );
                          })}
                        </div>
                      )}
                    </div>
                  )}

                  {filters.show.properties && (
                    <div className="search-properties-container">
                      <div className="properties-card-top">
                        <div className="result">
                          Inventory Properties ({Result?.properties?.length})
                        </div>
                        <div
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            if (Result?.properties?.length === 0) {
                              setInventoryPropertiesToggler(true);
                            } else {
                              setInventoryPropertiesToggler(
                                !InventoryPropertiesToggler
                              );
                            }
                          }}
                          className="toggler"
                        >
                          {InventoryPropertiesToggler ? (
                            <img src={SearchResultToggler} alt="" />
                          ) : (
                            <img
                              style={{ transform: "rotateZ(180deg)" }}
                              src={SearchResultToggler}
                              alt=""
                            />
                          )}
                        </div>
                      </div>
                      {InventoryPropertiesToggler && (
                        <div className="properties-card-body">
                          {Result?.properties?.map((e) => (
                            <PropertiesContent
                              property={e.document}
                              setOpenSearch={setOpenSearch}
                              openSearch={openSearch}
                            />
                          ))}
                        </div>
                      )}
                    </div>
                  )}

                  {filters.show.sharedProperties && (
                    <div className="search-properties-container">
                      <div className="properties-card-top">
                        <div className="result">
                          Shared Properties ({Result?.sharedProperties?.length})
                        </div>
                        <div
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            if (Result?.sharedProperties?.length === 0) {
                              setSharedPropertiesToggler(true);
                            } else {
                              setSharedPropertiesToggler(
                                !SharedPropertiesToggler
                              );
                            }
                          }}
                          className="toggler"
                        >
                          {SharedPropertiesToggler ? (
                            <img src={SearchResultToggler} alt="" />
                          ) : (
                            <img
                              style={{ transform: "rotateZ(180deg)" }}
                              src={SearchResultToggler}
                              alt=""
                            />
                          )}
                        </div>
                      </div>
                      {SharedPropertiesToggler && (
                        <div className="properties-card-body">
                          {Result?.sharedProperties?.map((e) => (
                            <PropertiesContent
                              property={e.document}
                              setOpenSearch={setOpenSearch}
                              openSearch={openSearch}
                            />
                          ))}
                        </div>
                      )}
                    </div>
                  )}

                  {filters.show.publicProperties && (
                    <div className="search-properties-container">
                      <div className="properties-card-top">
                        <div className="result">
                          Public Properties ({Result?.publicProperties?.length})
                        </div>
                        <div
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            if (Result?.publicProperties?.length === 0) {
                              setPublicPropertiesToggler(true);
                            } else {
                              setPublicPropertiesToggler(
                                !PublicPropertiesToggler
                              );
                            }
                          }}
                          className="toggler"
                        >
                          {PublicPropertiesToggler ? (
                            <img src={SearchResultToggler} alt="" />
                          ) : (
                            <img
                              style={{ transform: "rotateZ(180deg)" }}
                              src={SearchResultToggler}
                              alt=""
                            />
                          )}
                        </div>
                      </div>
                      {PublicPropertiesToggler && (
                        <div className="properties-card-body">
                          {Result?.publicProperties?.map((e) => (
                            <PropertiesContent
                              property={e.document}
                              setOpenSearch={setOpenSearch}
                              openSearch={openSearch}
                            />
                          ))}
                        </div>
                      )}
                    </div>
                  )}

                  {filters.show.leads && (
                    <div className="search-client-container">
                      <div className="client-card-top">
                        <div className="result">
                          Clients ({Result?.leads?.length})
                        </div>
                        <div
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            if (Result?.leads?.length === 0) {
                              setClientsToggler(true);
                            } else {
                              setClientsToggler(!ClientsToggler);
                            }
                          }}
                          className="toggler"
                        >
                          {ClientsToggler ? (
                            <img src={SearchResultToggler} alt="" />
                          ) : (
                            <img
                              style={{ transform: "rotateZ(180deg)" }}
                              src={SearchResultToggler}
                              alt=""
                            />
                          )}
                        </div>
                      </div>
                      {ClientsToggler && (
                        <div className="client-card-body">
                          {Result?.leads?.map((e) => (
                            <SearchClientsContent
                              key={e.document?.id}
                              id={e.document?.id}
                              name={e.document?.name}
                              dateTime={e.document?.createdAt}
                              phone={e.document?.phone}
                              email={e.document?.email}
                              cnic={e.document?.cnic}
                              address={e.document?.address}
                              setOpenSearch={setOpenSearch}
                            />
                          ))}
                        </div>
                      )}
                    </div>
                  )}

                  {filters.show.agents && (
                    <div className="search-agent-container">
                      <div className="agent-card-top">
                        <div className="result">Agents ({agents?.length})</div>
                        <div
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            if (agents?.length === 0) {
                              setAgentsToggler(true);
                            } else {
                              setAgentsToggler(!AgentsToggler);
                            }
                          }}
                          className="toggler"
                        >
                          {AgentsToggler ? (
                            <img src={SearchResultToggler} alt="" />
                          ) : (
                            <img
                              style={{ transform: "rotateZ(180deg)" }}
                              src={SearchResultToggler}
                              alt=""
                            />
                          )}
                        </div>
                      </div>
                      {AgentsToggler && (
                        <div className="agent-card-body">
                          {agents?.map((e) => (
                            <SearchAgentsContent
                              key={e.id}
                              id={e.id}
                              name={e.name}
                              dateTime={e?.createdAt
                                ?.toDate()
                                ?.toLocaleString("en-GB", {
                                  year: "numeric",
                                  month: "short",
                                  day: "numeric",
                                })}
                              phone={e.number}
                              email={e.email}
                              address={e.address}
                              status={e.status}
                              setOpenSearch={setOpenSearch}
                            />
                          ))}
                        </div>
                      )}
                    </div>
                  )}
                  {GetTotalResultCount() === 0 && (
                    <div className="search-no-data-found">
                      <NoDataFound />
                    </div>
                  )}
                </div>
              )}
            </Fragment>
          </div>
        </div>

        <div className="header-right-container">
          <div className="notifications-icon" ref={NotificationDropDownRef}>
            <div onClick={handleNotificationClickDropDown}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="22"
                viewBox="0 0 20 22"
                fill="none"
              >
                <path
                  d="M16 7C16 5.4087 15.3679 3.88258 14.2426 2.75736C13.1174 1.63214 11.5913 1 10 1C8.4087 1 6.88258 1.63214 5.75736 2.75736C4.63214 3.88258 4 5.4087 4 7C4 14 1 16 1 16H19C19 16 16 14 16 7Z"
                  stroke={Colors.themeColorSmallAfter}
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M11.73 20C11.5542 20.3031 11.3018 20.5547 10.9982 20.7295C10.6946 20.9044 10.3504 20.9965 9.99999 20.9965C9.64961 20.9965 9.30538 20.9044 9.00176 20.7295C8.69815 20.5547 8.4458 20.3031 8.26999 20"
                  stroke={Colors.themeColorSmallAfter}
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              {Notifications &&
                Notifications.length !== 0 &&
                Notifications[0].is_seen === false && (
                  <div className="pulse-css"></div>
                )}
            </div>

            {ToggleNotification && (
              <div className="header-notifications-dropdown">
                {Notifications && Notifications.length === 0 && (
                  <p
                    style={{
                      position: "absolute",
                      top: "44%",
                      left: "35%",
                    }}
                  >
                    No Notifications
                  </p>
                )}
                <div className="header-notifications-dropdown-content">
                  {Notifications && Notifications.length !== 0 && (
                    <div className="notifications-dropdown-title">
                      Recent Notifications
                    </div>
                  )}
                  <div className="dropdown-notifications-list">
                    <Fragment>
                      {Notifications &&
                        Notifications.map((notification) => {
                          return (
                            <Link
                              onClick={() => {
                                setToggleNotification(false);
                              }}
                              key={notification?.id}
                              to={notification.notification_link.substring(29)}
                            >
                              {" "}
                              <NotificationsPopup
                                key={notification?.id}
                                notification={notification}
                              />
                            </Link>
                          );
                        })}
                    </Fragment>
                  </div>
                </div>
                {Notifications?.length !== 0 && (
                  <div
                    className="all-notification all-notification-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      setToggleNotification(false);
                      navigate("/user/notifications");
                    }}
                  >
                    See all notifications <i className="ti-arrow-right"></i>
                  </div>
                )}
              </div>
            )}
          </div>
          <div
            ref={DropDownRef}
            className="user-profile"
            onClick={handleClickDropDown}
          >
            <div className="user-name">
              <span>
                {ProfileData && "Hello, "}
                <strong>{ProfileData?.name}</strong>
              </span>
            </div>
            <div className="user-header-image">
              {ProfileData?.image_url && (
                <div
                  className="headerProfileImage"
                  style={{
                    backgroundImage: `url(${ProfileData?.image_url})`,
                  }}
                  // onClick={() => setDropDown(true)}
                ></div>
              )}

              {!ProfileData?.image_url && ProfileData.name && (
                <Avatar
                  className="user-header-avatar"
                  {...stringAvatar(ProfileData.name)}
                />
              )}

              {!ProfileData.image_url &&
                !ProfileData.name &&
                ProfileData.phoneNumber && (
                  <Avatar
                    className="user-header-avatar"
                    {...stringAvatar("Profile Photo")}
                  />
                )}
            </div>

            {IsImageUploading && (
              <div className="headerLoading">Loading...</div>
            )}
            {DropDown && (
              <div
                className="dropdown-custom"
                // ref={DropDownRef}
                onClick={() => setDropDown(false)}
              >
                <Link to={"/user/profile"} className="dropdown-item ai-icon">
                  <svg
                    id="icon-user1"
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                  </svg>
                  <span className="dropdown-custom-margin">Profile </span>
                </Link>

                <a
                  href="/login"
                  className="dropdown-item ai-icon"
                  onClick={Logout}
                >
                  <svg
                    id="icon-logout"
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                    <polyline points="16 17 21 12 16 7"></polyline>
                    <line x1="21" y1="12" x2="9" y2="12"></line>
                  </svg>
                  <span className="dropdown-custom-margin">Logout </span>
                </a>
              </div>
            )}
          </div>
        </div>
      </header>
      <div className="App">
        {show ? (
          <ReactNotificationComponent
            title={notification.title}
            body={notification.body}
          />
        ) : (
          <></>
        )}
        <PushNotifications />
      </div>
    </>
  );
};

const mapStateToProps = (state) => state;

export default connect(mapStateToProps)(Header);
